import {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {AllFonts} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/AllFonts/AllFonts';
import {RecentlyUsedFonts} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/RecentlyUsedFonts/RecentlyUsedFonts';
import {mapFabricFontToLocal} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/utils';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {useRecentlyUsedFonts} from '~/common/FabricInvitation/EventCreateDesign/FontProvider';
import {Typography} from '~library/atoms/Typography';
import {FontCategoryPills} from './FontCategoryPills/FontCategoryPills';

import './FontsMobile.sass';

export const FontsMobile = () => {
  const {canvas} = useContext(EventCreateContext);
  const [selectedValue, setSelectedValue] = useState({});
  const activeObjects = canvas?.getActiveObjects();
  const initializeRender = useRef(false);
  const {
    recentlyUsedFonts,
    updateRecentlyUsedFont,
    selectedCategories,
    setSelectedCategories,
    categoryFonts,
    setCategoryFonts,
  } = useRecentlyUsedFonts();

  useEffect(() => {
    setSelectedValue(mapFabricFontToLocal(activeObjects?.[0]));
  }, [activeObjects?.[0]]);

  const onChangeHandler = useCallback(
    (value) => {
      setSelectedValue(value);
      activeObjects.forEach((obj) =>
        obj.set({
          fontFamily: value.family,
          fontStyle: value.style,
          fontWeight: value.weight,
        })
      );
      canvas.requestRenderAll();
      canvas.fire('object:modified');
      const selectedFont = {
        family: value.family,
        style: value.style,
        weight: value.weight,
        name: value.name,
      };
      updateRecentlyUsedFont(selectedFont);
    },
    [canvas, activeObjects, updateRecentlyUsedFont]
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: missing deps, use useEffectEvent instead
  useEffect(() => {
    if (activeObjects?.length) {
      const canvasWrapper = document.querySelector('.event-create-design');
      const y = activeObjects[0].top / 2 - canvasWrapper.clientHeight / 2 + 40;
      canvasWrapper.scrollTo({
        top: y,
        left: 0,
        behavior: 'smooth',
      });

      let recentlyUsedFontIsSelectedValue = true;
      if (recentlyUsedFonts[0] && selectedValue) {
        recentlyUsedFontIsSelectedValue =
          recentlyUsedFonts[0].family !== selectedValue.family ||
          recentlyUsedFonts[0].style !== selectedValue.style ||
          recentlyUsedFonts[0].weight !== selectedValue.weight;
      }

      if (initializeRender.current && selectedValue && recentlyUsedFontIsSelectedValue) {
        const selectedFont = {
          family: selectedValue.family,
          style: selectedValue.style,
          weight: selectedValue.weight,
          name: selectedValue.name,
        };
        updateRecentlyUsedFont(selectedFont);
        initializeRender.current = false;
      }
      initializeRender.current = true;
    }
  }, [activeObjects]);

  return (
    <div className="fonts__mobile create-flow__texteditor-content">
      <div className="fonts__mobile-dropdown">
        <div className="fonts__mobile-header">
          <FontCategoryPills
            selectedCategories={selectedCategories}
            setCategoryFonts={setCategoryFonts}
            setSelectedCategories={setSelectedCategories}
          />
        </div>
        {recentlyUsedFonts.filter((obj) => Object.keys(obj).length).length > 0 &&
          selectedCategories.length < 1 && (
            <>
              <Typography
                as="h1"
                variant="label2"
                semibold="true"
                color="pebble"
                className="fonts__mobile-title"
              >
                Recently Used
              </Typography>
              <div className="fonts__mobile-recent">
                <RecentlyUsedFonts onClick={onChangeHandler} selectedFont={selectedValue} />
              </div>
            </>
          )}
        {selectedCategories.length > 0
          ? selectedCategories.map((selectedCategory) => (
              <div className="fonts__mobile-font-families" key={selectedCategory}>
                <Typography
                  as="h1"
                  variant="label2"
                  color="pebble"
                  semibold="true"
                  className="fonts__mobile-title"
                >
                  {selectedCategory} (
                  {categoryFonts[selectedCategory]?.length
                    ? categoryFonts[selectedCategory].reduce((total, font) => {
                        const fontVariations = font.styles.length * font.weights.length;
                        return total + fontVariations;
                      }, 0)
                    : 0}
                  )
                </Typography>
                <div className="fonts__mobile-category">
                  <AllFonts
                    onClick={onChangeHandler}
                    selectedFont={selectedValue}
                    allFonts={categoryFonts[selectedCategory]}
                  />
                </div>
              </div>
            ))
          : <div className="fonts__mobile-font-families">
              <Typography
                as="h1"
                variant="label2"
                semibold="true"
                color="pebble"
                className="fonts__mobile-title"
              >
                All fonts (
                {window.fonts.reduce((total, font) => {
                  const fontVariations = font.styles.length * font.weights.length;
                  return total + fontVariations;
                }, 0)}
                )
              </Typography>
              <div className="fonts__mobile-all">
                <AllFonts
                  onClick={onChangeHandler}
                  selectedFont={selectedValue}
                  allFonts={window.fonts}
                />
              </div>
            </div>}
      </div>
    </div>
  );
};
